export default "__VITE_ASSET__9lheP1bn__"